import { render, staticRenderFns } from "./institutionalGroupProduct.vue?vue&type=template&id=ff8cd838&scoped=true"
import script from "./institutionalGroupProduct.vue?vue&type=script&lang=js"
export * from "./institutionalGroupProduct.vue?vue&type=script&lang=js"
import style0 from "./institutionalGroupProduct.vue?vue&type=style&index=0&id=ff8cd838&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8cd838",
  null
  
)

export default component.exports